const ErrorMessage = ({ message, title = 'Hoppsan, något gick fel' }) => {
    console.error('Error:', message);

    return (
        <div className="error-message">
            <p className="error-title">{title}</p>
            <p className="error-text">
                {message || 'Vi kunde inte ladda informationen just nu. Försök igen snart.'}
            </p>
        </div>
    );
};

export default ErrorMessage;
